import {
  SCALING,
  SPICE_MAGIC
} from "../../../src/actions/scaling-presets";
import { Targeting } from "../../../src/actions/targeting";
import { MELEE_WINDUP } from "../../../src/actions/impacts";
import { SEC } from "../../../src/time-utils";
const sword_slash = {
  slug: "sword_slash",
  name: "Sword Slash",
  abilityIcon: "sword_slash",
  description: "Hack and slash",
  costs: [
    {
      stat: "energy",
      value: 10
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: 0,
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.SLASHING
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword"]
};
const flame_slash = {
  slug: "flame_slash",
  name: "Flame Slash",
  abilityIcon: "flame_slash",
  description: "A blazing strike that ignites the blade",
  costs: [
    {
      stat: "energy",
      value: 15
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(3),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                red: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword", "red"]
};
const shadow_slash = {
  slug: "shadow_slash",
  name: "Shadow Slash",
  abilityIcon: "shadow_slash",
  description: "A strike from darkness that seeps into the wound",
  costs: [
    {
      stat: "energy",
      value: 15
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(3),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                black: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword", "black"]
};
const radiant_slash = {
  slug: "radiant_slash",
  name: "Radiant Slash",
  abilityIcon: "radiant_slash",
  description: "A blessed strike that blazes with holy light",
  costs: [
    {
      stat: "energy",
      value: 15
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(3),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                gold: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword", "gold"]
};
const static_slash = {
  slug: "static_slash",
  name: "Static Slash",
  abilityIcon: "static_slash",
  description: "A shocking strike that crackles with electrical energy",
  costs: [
    {
      stat: "energy",
      value: 15
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(3),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                blue: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword", "blue"]
};
const nature_slash = {
  slug: "nature_slash",
  name: "Nature Slash",
  abilityIcon: "nature_slash",
  description: "A strike infused with the wild force of nature",
  costs: [
    {
      stat: "energy",
      value: 15
    }
  ],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(3),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: [{ q: 0, r: 0 }],
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.SLASHING,
                green: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "melee", "sword", "green"]
};
export {
  flame_slash,
  nature_slash,
  radiant_slash,
  shadow_slash,
  static_slash,
  sword_slash
};
//# sourceMappingURL=data:application/json;base64,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
